// export default () => ({
// })

export default () => ({
    lots: [],
    lotsSelectable: [],
    lotsPaginatedData: null,
    lot: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,
    existingLot: null,
    isFinding: false,
})